import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/697b3017921dc900141be80b/cis_solutions/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697b3017921dc900141be80b/cis_solutions/src/components/ui/AppIcon.tsx");
